import { AloDataPoolItem } from '@/models/alo/AloDataPoolItem'

export interface IDataPoolState {
  status: string
  dataPoolItemsById: { [id: number]: AloDataPoolItem }
}

const state: IDataPoolState = {
  status: '',
  dataPoolItemsById: {}
}

export default state
